module.exports = {"510304001":"大安街道","510304002":"龙井街道","510304003":"马冲口街道","510304004":"凉高山街道","510304100":"大山铺镇","510304102":"团结镇","510304103":"三多寨镇","510304104":"何市镇","510304105":"新店镇","510304106":"新民镇","510304107":"牛佛镇","510304108":"庙坝镇","510304109":"回龙镇","510304204":"永嘉乡","510304205":"和平乡","510304207":"凤凰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510304.json
// module id = 2277
// module chunks = 0